import '../../style/index.less';
// style dependencies
import '../../popover/style';
import '../../button/style';



// WEBPACK FOOTER //
// ./components/popconfirm/style/index.tsx